export const environment = {
  t: 'Bag2Bag Hotels and Homes',
  d: 'Bag2Bag: Book hotels by the hour or day for ultimate flexibility.',
  m: 1,

  appVersion: '8.50.75',
  iosAppVersion: '1.0.63',
  cacheVersion: 42,
  appVersionCode: '805075',
  iosAppVersionCode: '100063',

  cacheKey: '_wst_:ch_',
  production: false,
  enableSW: false,
  gtmID: 'GTM-KTSBBXV', // Test
  hostWebsite: 'https://stage.bag2bag.in',
  // baseHref: 'https://stage.bag2bag.in/',
  baseHref: '/',
  restAPI: 'https://stage-api-v2.bag2bag.in/v2/',
  // restAPI: 'http://localhost:9000/v2/',
  razorPayKey: 'rzp_test_EtjkHST0InxSud',
  stripeKey:
    'pk_test_51MJVoZSDt6Pe4GIw0A4rQslq8MnLgyvgYWpMzwSUczKuXetRywHjrWSTZMAUoDD82HjVI2afeCDqOxzcicBExB1E00zPaCmY9t',
  citiesImagePath:
    'https://static.bag2bag.in/png/assets/images/new-city-images/',
  couponsImagePath:
    'https://static.bag2bag.in/png/assets/images/new-coupon-images/',
  appShellConfig: {
    debug: false,
    networkDelay: 500,
  },
  b2bLogo: `https://static.bag2bag.in/assets/images/footer-logo.svg`,
  paytmConf: {
    // paytmMerchantId: 'mUUAqY80240610016523',
    // isStaging: true,
    // callbackURL:
    //   'https://securegw-stage.paytm.in/theia/paytmCallback?ORDER_ID=',
    script:
      'https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/mUUAqY80240610016523.js',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBaCByLAXHJcwmEbBrcKlnC-EakCRwLxdg',
    authDomain: 'bag2bag-in.firebaseapp.com',
    databaseURL: 'https://bag2bag-in.firebaseio.com',
    projectId: 'bag2bag-in',
    storageBucket: 'bag2bag-in.appspot.com',
    messagingSenderId: '597671875782',
    appId: '1:597671875782:web:58517b2f4cb81ce3e1b3c7',
    measurementId: 'G-FEKG3PFE3J',
  },
  staticData: {
    iconsPath: 'https://static.bag2bag.in/new-assets/india/new-app/icons/',
  },
  webApp: true,
  mobileApp: false,
  extranetUrl: 'https://extranet.bag2bag.in',
  mobileAppLink: 'https://app.bag2bag.in/download-app',
  imgHost: 'https://static-img.bag2bag.in',
  OLA: {
    OLA_API_KEY: '2BVXKEH6orLOYR7gBNEA5r3He2hBkJwx9sVjYzAZ',
    OLA_MAP_STYLE:
      'https://api.olamaps.io/styleEditor/v1/styleEdit/styles/025318a7-c7c3-4087-8a05-fe52e1fd0e4f/b2b-light-theme',
  },
  apple_id: '1563969368',
};
